import { OF } from '../../util/network';
import { JBaseApi } from '../base';

import { ApiWrapper, Format } from '../../types/utils';
import { CalendarCombinedEventsList, CalendarOldEvent } from 'src/types/calendar';

export class JCalendarApi extends JBaseApi {
    public getEvents(params: {
        end?: string;
        start?: string;
        mode?: 'spot' | 'user';
        idSpot?: number;
        idArticle?: number;
    }): Promise<ApiWrapper<CalendarOldEvent[]>> {
        return this.network.post({ o: 'calendar', f: 'getEvents', ...params } as OF);
    }
    public getLastEvents(params: {
        uriContext?: string;
        page?: number;
        limit?: number;
        format?: Format;
    }): Promise<ApiWrapper<CalendarCombinedEventsList[]>> {
        return this.network.post({ o: 'calendar', f: 'getLastEvents', ...params } as OF);
    }
}
